import * as React from 'react'
import { Text, Block, Button, Division } from '$views/components'
import { LocationSearchInput } from '$views/FullMapCaretakers/components/LocationSearchInput'
import { ModalBox } from '$views/components/ModalBox'
import { ErrorText } from '$views/components/Input'

interface Props {
  onClickButton: (location) => void
}

export const SearchInputModal: React.FC<Props> = ({ onClickButton }) => {
  const [location, setLocation] = React.useState<google.maps.GeocoderResult>(undefined)
  const [validate, setValidate] = React.useState<boolean>(false)

  const updateLocation = updatedLocation => setLocation(updatedLocation)

  const onClick = (updatedLocation: google.maps.GeocoderResult) => {
    setValidate(true)
    if (updatedLocation) {
      onClickButton(updatedLocation)
    }
  }

  const getAddress = () => (location ? location.formatted_address : '')

  return (
    <>
      <ModalBox onAcceptClick={() => ''} buttonLabel="" simple>
        <Text subheader marginBottom="mini" marginTop="small">
          Encuentra profesionales cerca de...
        </Text>
        <LocationSearchInput
          address={getAddress()}
          onPlaceChanged={updateLocation}
          placeholder="Ciudad, código postal, calle..."
        />
        {location && !location.formatted_address && validate && (
          <>
            <ErrorText as="p" caption error>
              Indica una dirección. La utilizaremos para seleccionar profesionales cercanos a ti
            </ErrorText>
            <Division marginTop="tiny" color="darkPink" marginBottom="medium" />
          </>
        )}
        <Block marginTop="mini">
          <Button primary fluid onClick={() => onClick(location)}>
            Ver
          </Button>
        </Block>
      </ModalBox>
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/FullMapCaretakers/components/SearchInputModal/SearchInputModal.tsx